'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Grid = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    display: grid;\n    grid-template-columns: repeat(', ', 1fr);\n    @media ', ' {\n      grid-template-columns: repeat(', ', 1fr);\n    }\n    @media ', ' {\n      grid-template-columns: repeat(', ', 1fr);\n    }\n    @media ', ' {\n      grid-template-columns: repeat(', ', 1fr);\n    }\n    grid-gap: 1em 1em;\n    align-items: stretch;\n    justify-items: strech;\n'], ['\n    display: grid;\n    grid-template-columns: repeat(', ', 1fr);\n    @media ', ' {\n      grid-template-columns: repeat(', ', 1fr);\n    }\n    @media ', ' {\n      grid-template-columns: repeat(', ', 1fr);\n    }\n    @media ', ' {\n      grid-template-columns: repeat(', ', 1fr);\n    }\n    grid-gap: 1em 1em;\n    align-items: stretch;\n    justify-items: strech;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
/*:: import * as React from 'react' */
/*:: import type {ComponentType} from 'react' */


/*::
type Props = {|
    sizes?: {
      mobile: number,
      tablet: number,
      laptop: number,
      desktop: number
    },
    children: React.Node
|}
*/
var Grid /*: ComponentType<Props> */ = exports.Grid = _styledComponents2.default.div(_templateObject, function (_ref) {
  var _ref$sizes = _ref.sizes;
  _ref$sizes = _ref$sizes === undefined ? {} : _ref$sizes;
  var _ref$sizes$mobile = _ref$sizes.mobile,
      mobile = _ref$sizes$mobile === undefined ? 1 : _ref$sizes$mobile;
  return mobile;
}, _styles.styles.media.tablet, function (_ref2) {
  var _ref2$sizes = _ref2.sizes;
  _ref2$sizes = _ref2$sizes === undefined ? {} : _ref2$sizes;
  var _ref2$sizes$tablet = _ref2$sizes.tablet,
      tablet = _ref2$sizes$tablet === undefined ? 2 : _ref2$sizes$tablet;
  return tablet;
}, _styles.styles.media.laptop, function (_ref3) {
  var _ref3$sizes = _ref3.sizes;
  _ref3$sizes = _ref3$sizes === undefined ? {} : _ref3$sizes;
  var _ref3$sizes$laptop = _ref3$sizes.laptop,
      laptop = _ref3$sizes$laptop === undefined ? 3 : _ref3$sizes$laptop;
  return laptop;
}, _styles.styles.media.desktop, function (_ref4) {
  var _ref4$sizes = _ref4.sizes;
  _ref4$sizes = _ref4$sizes === undefined ? {} : _ref4$sizes;
  var _ref4$sizes$desktop = _ref4$sizes.desktop,
      desktop = _ref4$sizes$desktop === undefined ? 4 : _ref4$sizes$desktop;
  return desktop;
});
Grid.displayName = 'Grid';


//////////////////
// WEBPACK FOOTER
// ../tutellus-ui/lib/Grid.js
// module id = 235
// module chunks = 0